import { FC } from 'react'

import { Container, PageHeading } from '~/components'
import { ContactMethods } from '~/features/common/contact-methods'

import { OfficeContactForm, OfficeContactInfoCard } from '../components'

type PrefecturePageProps = {
  officeContactInfo: React.ComponentProps<typeof OfficeContactInfoCard>
}

export const OfficeContactPage: FC<PrefecturePageProps> = ({
  officeContactInfo,
}) => {
  return (
    <main>
      <div className="bg-grayBg md:p-[38px]">
        <Container className="flex max-w-[600px] flex-col gap-y-10 bg-white py-6 md:rounded-lg md:px-6">
          <PageHeading>お問い合わせ</PageHeading>

          <section aria-label="office-info-section">
            <div className="flex flex-col gap-y-2">
              <h3 className="text-body font-normal">
                お問い合わせするオフィス
              </h3>
              <div className="flex flex-col gap-y-10">
                <OfficeContactInfoCard {...officeContactInfo} />
                <ContactMethods
                  note={`「${officeContactInfo.officeName}の件で」とお伝えください`}
                />
                <OfficeContactForm />
              </div>
            </div>
          </section>
        </Container>
      </div>
    </main>
  )
}
